import { connect } from 'react-redux';
import { loadLicenses, deleteLicense } from 'data/licenses/licenses.actions';
import LicenseTableCardContainer from './LicenseTableCardContainer';

const key = Symbol('LicenseTableCard');
const actions = {
  loadLicenses: () => loadLicenses(key),
  deleteLicense: id => deleteLicense(key, id)
};

function mapStateToProps(state) {
  return {
    ...state.licenses[key],
  };
}

export default connect(mapStateToProps, actions)(LicenseTableCardContainer);
